import React from 'react'
import { DefaultDataTable } from '../../../components/dataTable/DefaultDataTable'
export const WebhookPixAutomaticoList = (props) => <DefaultDataTable data={props} />
